export default __webpack_public_path__ + "src/images/bg_dot_work_info-c42888.png";